import React from 'react';
import { Grid, Paper, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const ServerError = () => {
  const theme = useTheme();

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      spacing={4}
      direction="column"
    >
      <Grid item>
        <Paper
          elevation={2}
          style={{
            padding: theme.spacing(4),
            margin: theme.spacing(6),
            width: '50vw',
          }}
        >
          <Grid item>
            <Typography gutterBottom align="center" variant="h5">
              <strong>We're having trouble loading your data</strong>
            </Typography>
          </Grid>
          <Grid item style={{ marginTop: theme.spacing(2) }}>
            <Typography align="center" variant="body1">
              Our servers are experiencing some issues. Please try again in a
              few minutes.
            </Typography>
          </Grid>
          <Grid item style={{ marginTop: theme.spacing(4) }}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={() => window.location.reload()}
                >
                  Refresh Page
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};
